import { render, staticRenderFns } from "./SessionDurationChart.vue?vue&type=template&id=4afecc2a"
import script from "./SessionDurationChart.vue?vue&type=script&lang=ts"
export * from "./SessionDurationChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports